module.exports = __webpack_public_path__ + "static/p09_sombraPajaros-362a3a5403341ab6566cdac065944248.jpg";